<template>
  <div
    :id="`${name}_card-wrapper`"
    class="c-checkboxes-group-field"
    :question-id="`question_${questionNum}`"
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]"
  >
    <div class="card" :class="[cardStyle.class]" :style="[cardStyle.style]">
      <div class="card-content">
        <p class="check-box-p" v-if="customMod === 'listing'">
          <label>
            <input
              type="checkbox"
              class="filled-in"
              :disabled="isDisabled"
              :v-bind-true="true"
              :v-bind:false="false"
              v-model="fieldValue"
            />
            <span></span>
          </label>
        </p>
        <div class="card-title" v-if="titleText">
          <div class="title-text">{{ titleText }}</div>
        </div>
        <div class="label-container">
          <div class="question-number" v-if="showQuestionNum">
            {{ questionNum + "." }}
          </div>
          <div class="label-text" v-html="label"></div>
        </div>
        <div class="btn-guide-wrapper" v-if="guideButtonText">
          <button
            class="btn btn-rounded waves-effect  btn-guide"
            :class="[guideButtonStyle.class]"
            :style="[guideButtonStyle.style]"
          >
            {{ guideButtonText }}
          </button>
        </div>
        <div
          class=" options-container options-row"
          v-if="customMod === 'listing'"
        >
        <div class="description">
          <span v-html="description"></span>
        </div>
          <ol class="browser-default">
            <li
              style="list-style-type: lower-alpha; margin-bottom: 6px;"
              class="option-wrapper"
              :class="[$_getGrid(), { 'center-align': imageStyle }]"
              v-for="(opt, index) in options"
              :key="index"
            >
              <span v-html="opt.text"></span>
            </li>
          </ol>
          <div class="clear"></div>
        </div>
        <div class="options-container row " v-else>
          <div
            class="option-wrapper"
            :class="[$_getGrid(), { 'center-align': imageStyle }]"
            v-for="(opt, index) in options"
            :key="index"
          >
            <div
              class="option"
              :class="[
                { active: fieldValue.includes(opt.value) && !imageStyle },
              ]"
            >
              <!-- <span v-if="!imageStyle" v-html="opt.text"></span> -->
              <label class="cp-label">
                <input
                  type="checkbox"
                  class="filled-in"
                  :disabled="!viewConditions || isDisabled"
                  :value="opt.value"
                  v-model="fieldValue"
                />
                <span v-if="!imageStyle" v-html="opt.text"></span>
                <span v-else></span>
              </label>
            </div>
          </div>
        </div>

        <component
          :is="componentLoader"
          :data-value="dataAdditionalValue"
          @updateValue="$_updateAdditionalValue"
          :data-disable="conditionChecker()"
          v-if="componentLoader"
        ></component>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomGroupCheckboxesField",
  props: {
    value: {
      type: [Array, String, Boolean],
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    dataAdditionalValue: {
      type: String,
      default: "",
    },
    componentLoader: {
      type: [Object, Array, Boolean],
      default: false,
    },
    additionalCondition: {
      type: [String, Number],
      default: "",
    },
    hasCondition: {
      type: [Boolean],
      default: false,
    },
    viewConditions: {
      type: Boolean,
      default: true,
    },
    customMod: {
      type: String,
      default: "listing",
    },
    imageStyle: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      required: false,
    },
    guideButtonText: {
      type: String,
      default: () => "",
    },
    description: {
      default: String,
      default: () => "",
    },
    guideButtonStyle: {
      type: Object,
      default: () => ({}),
    },
    titleText: {
      type: String,
      default: () => "",
    },
    questionNum: {
      type: Number,
      default: () => null,
    },
    showQuestionNum: {
      type: Boolean,
      default: false,
    },
    gridStyle: {
      type: [Object],
      default: () => ({}),
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    cardStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    error: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },
  data() {
    return {
      fieldValue: this.value,
      mainValue: false,
      otherOption: "other_option_random",
      disableAdditional: false,
    };
  },
  created() {
    this.$_setMainValue();
    // console.log(this.value);
  },
  watch: {
    mainValue(nV) {
      /* if (nV === false) this.fieldValue = [];
      if (nV === true && this.fieldValue.length <= 0) */
      //this.fieldValue.push(this.otherOption);
      this.$emit("update", this.fieldValue);
    },
    fieldValue(nV) {
      this.$emit("update", this.fieldValue);
      /*    if (nV.length > 0 && !this.mainValue) {
        this.mainValue = true;
       // this.fieldValue.push(this.otherOption);
      } */
      // this.$emit("update", this.fieldValue);
    },
  },
  computed: {
    optOne() {
      return this.options[0];
    },
    optTwo() {
      return this.options[1];
    },
  },
  methods: {
    $_setMainValue() {
      // if (this.value.length > 0) {
      this.mainValue = this.value;
      //  }
    },

    $_updateAdditionalValue(val) {
      this.$emit("updateAdditional", val);
    },
    $_getImg(pic) {
      if (pic) {
        return require("@/assets/" + pic);
      }
    },
    $_updateValue(opt) {
      if (!this.fieldValue.includes(opt.value)) {
        this.fieldValue.push(opt.value);
      } else {
        this.fieldValue = this.fieldValue.filter((item) => item !== opt.value);
      }
      this.$emit("update", this.fieldValue);
    },
    $_getGrid() {
      if (!this.gridStyle.grid) {
        // return this.options.length > 4 ? "col s3" : "col s6";
        return "col s6";
      } else {
        return this.gridStyle.grid;
      }
    },
    conditionChecker() {
      if (!this.hasCondition) return true;

      if (this.fieldValue.includes(this.additionalCondition)) return false;

      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.c-checkboxes-group-field {
  .card {
    .card-title {
      display: flex;
    }
    .card-content {
      .btn-guide-wrapper {
        margin: 2rem 0 0 0;
        display: flex;
        justify-content: center;
        .btn-guide {
          padding: 0 2rem;
        }
      }
      .label-container {
        display: flex;
      }
    }
  }
  .btn-container {
    margin: 1rem 0;
  }
}
.options-container {
  margin-bottom: 0px !important;
  padding: 8px 0px 16px 16px;
  background: #f9f9f9;
  margin-top: 10px;
  border-radius: 4px;
  .option {
    position: relative;
    margin-top: 10px;
    .trigger {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 100;
    }
  }
}
.label-text {
  font-size: 18px;
  transform: translateY(-2px);
}
.question-number {
  font-size: 18px;
  line-height: 24px;
  margin-right: 6px;
}
.check-box-p {
  float: left;
  width: 30px;
  /* padding-left: 24px; */
  margin-right: 0px;
}
.cp-label {
  span {
    font-size: 14.5px;
    line-height: 20px;
    /*margin-bottom: 12px; */
  }
}
</style>
